import { render, staticRenderFns } from "./EditEnrollmentDialog.vue?vue&type=template&id=723df48c&scoped=true"
import script from "./EditEnrollmentDialog.vue?vue&type=script&lang=js"
export * from "./EditEnrollmentDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723df48c",
  null
  
)

export default component.exports